function n() {
  return "undefined" == typeof window;
}
function e() {
  return !n();
}
export { e as isClientSideRendered, n as isServerSideRendered };